import axios from "axios";
import { STRIPE_ACCOUNT_URL } from "../utils";

export const fetchStripeAccount = async () => {
  return await axios.get(STRIPE_ACCOUNT_URL);
};
